var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFocus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic32/focus"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M27 16C27 21.5228 22.5228 26 17 26M27 16C27 10.4772 22.5228 6 17 6M27 16H23M17 26C11.4772 26 7 21.5228 7 16M17 26V22M7 16C7 10.4772 11.4772 6 17 6M7 16H11M17 6V10",
    stroke: "#E6E6E6",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFocus);
export default __webpack_public_path__ + "static/media/focus.ea330265204200d495715611e0ffa4be.svg";
export { ForwardRef as ReactComponent };